import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-486e2320"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "background-gradient-saturated base flex" }
const _hoisted_2 = { class: "center" }
const _hoisted_3 = { class: "drawer" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", null, "Register", -1))
const _hoisted_5 = { class: "button-container" }
const _hoisted_6 = /*#__PURE__*/_createTextVNode(" Register ")
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, " Already have an account? ", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_WelcomeGem = _resolveComponent("WelcomeGem")!
  const _component_van_field = _resolveComponent("van-field")!
  const _component_van_button = _resolveComponent("van-button")!
  const _component_van_form = _resolveComponent("van-form")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_WelcomeGem, {
        gemColor: _ctx.GemColor.PINK
      }, null, 8, ["gemColor"]),
      _createElementVNode("div", _hoisted_3, [
        _hoisted_4,
        _createVNode(_component_van_form, { onSubmit: _ctx.handleRegister }, {
          default: _withCtx(() => [
            _createVNode(_component_van_field, {
              modelValue: _ctx.fullName,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.fullName) = $event)),
              name: "fullName",
              placeholder: "Full name",
              rules: [
              { required: true, message: 'Full name is required' },
              _ctx.charCountValidator,
            ]
            }, null, 8, ["modelValue", "rules"]),
            _createVNode(_component_van_field, {
              modelValue: _ctx.username,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.username) = $event)),
              name: "Username",
              placeholder: "Username",
              rules: [
              { required: true, message: 'Username is required' },
              _ctx.charCountValidator,
            ]
            }, null, 8, ["modelValue", "rules"]),
            _createVNode(_component_van_field, {
              modelValue: _ctx.password,
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.password) = $event)),
              type: "password",
              name: "Password",
              placeholder: "Password",
              rules: [
              { required: true, message: 'Password is required' },
              _ctx.charCountValidator,
            ]
            }, null, 8, ["modelValue", "rules"]),
            _createVNode(_component_van_field, {
              modelValue: _ctx.confirmPassword,
              "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.confirmPassword) = $event)),
              type: "password",
              name: "confirmPassword",
              placeholder: "Confirm password",
              rules: [
              { required: true, message: 'Confirm password is required' },
              {
                validator: _ctx.validatePasswordConfirmation,
                message: 'Passwords do not match',
              },
              _ctx.charCountValidator,
            ]
            }, null, 8, ["modelValue", "rules"]),
            _createElementVNode("div", _hoisted_5, [
              _createVNode(_component_van_button, {
                round: "",
                block: "",
                type: "primary",
                "native-type": "submit",
                width: "80%"
              }, {
                default: _withCtx(() => [
                  _hoisted_6
                ]),
                _: 1
              })
            ]),
            _hoisted_7,
            _createElementVNode("span", {
              class: "login-prompt",
              onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.goToLoginPage && _ctx.goToLoginPage(...args)))
            }, " Login ")
          ]),
          _: 1
        }, 8, ["onSubmit"])
      ])
    ])
  ]))
}